export { VpCaptionBadge } from './VpCaptionBadge';



// WEBPACK FOOTER //
// ./src/vp-ui/components/VpCaptionBadge/index.js